<div class="page">
  <app-page-header [title]="'admin.dogs.title' | translate" [backLabel]="'admin.dashboard.title' | translate" backLink="/admin/dashboard" />

  <div class="mb-8 bg-white dark:bg-slate-800 p-6 rounded-lg shadow-lg border border-slate-200 dark:border-slate-700">
    <h3 class="text-xl font-bold mb-4 text-slate-900 dark:text-slate-100">{{ 'admin.dogs.add' | translate }}</h3>
    <form [formGroup]="breedForm" (ngSubmit)="addBreed()" class="flex flex-col sm:flex-row gap-4 items-end">
      <div class="flex-1 w-full">
        <label class="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1">{{ 'admin.dogs.name' |
          translate }}</label>
        <input type="text" formControlName="name"
          class="field">
      </div>
      <div class="w-full sm:w-48">
        <label class="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1">{{ 'admin.dogs.category' |
          translate }}</label>
        <select formControlName="category"
          class="field">
          @for(cat of categories; track cat.value) {
          <option [value]="cat.value">{{ cat.label | translate }}</option>
          }
        </select>
      </div>
      <button type="submit" [disabled]="breedForm.invalid"
        class="btn btn-primary">
        {{ 'participants.form.save' | translate }}
      </button>
    </form>
  </div>

  <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8">
    @for (category of breedData(); track category.titleKey) {
    <div
      class="bg-white dark:bg-slate-800 rounded-lg shadow-lg border border-slate-200 dark:border-slate-700 flex flex-col h-96">
      <h3
        class="px-6 py-4 bg-slate-50 dark:bg-slate-700/50 text-xl font-bold text-slate-900 dark:text-slate-100 border-b border-slate-200 dark:border-slate-700 sticky top-0 z-10">
        {{ category.titleKey | translate }}
      </h3>
      <ul class="divide-y divide-slate-200 dark:divide-slate-700 overflow-y-auto flex-1">
        @for(breed of category.breeds; track breed) {
        <li
          class="px-6 py-2 hover:bg-slate-50 dark:hover:bg-slate-700/50 transition-colors flex justify-between items-center group">
          <span class="text-slate-800 dark:text-slate-200 text-sm">{{ breed }}</span>
          <button (click)="deleteBreed(breed)"
            class="text-red-500 opacity-0 group-hover:opacity-100 transition-opacity p-1 hover:bg-red-100 dark:hover:bg-red-900/30 rounded">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
            </svg>
          </button>
        </li>
        }
      </ul>
    </div>
    }
  </div>
</div>